import React from 'react';
import { Label } from 'react-bootstrap';

const Affids = ({ affids, onRemove }) => {
    const rows = affids.map(({ id, affid}, index) => {
        return <Label key={index} style={{fontSize: '12px', marginRight: '3px', display: 'inline-block'}}>
            {affid} <span onClick={() => onRemove(id)} style={{ cursor: 'pointer' }}>×</span>
        </Label>
    });

    return (
        <div>
            {rows}
        </div>
    )
};

export default Affids;


// WEBPACK FOOTER //
// ./src/scenes/BidderSourcesWhitelist/components/Blocks/components/Affids/index.js